module.exports = __webpack_public_path__ + "img/delivery_gray.bf48777f.svg";